import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
var BUTTON_TYPE = /* @__PURE__ */ ((BUTTON_TYPE2) => {
  BUTTON_TYPE2["PRIMARY"] = "primary";
  BUTTON_TYPE2["SUPPORT"] = "support";
  BUTTON_TYPE2["REVERSE"] = "reverse";
  BUTTON_TYPE2["OUTLINE"] = "outline";
  BUTTON_TYPE2["GHOST"] = "ghost";
  BUTTON_TYPE2["DESTRUCTIVE"] = "destructive";
  return BUTTON_TYPE2;
})(BUTTON_TYPE || {});
function customDialog({
  title,
  sub_title,
  message,
  buttons,
  outer_button_text
}) {
  const command = {
    command: INTERFACE.CUSTOM_DIALOG,
    parameters: {
      ...title && { title },
      ...sub_title && { sub_title },
      ...message && { message },
      ...outer_button_text && { outer_button_text },
      buttons
    }
  };
  return exec(command);
}
export {
  BUTTON_TYPE,
  customDialog
};
